import Image from 'next/image';
import s from './LocationBlock.module.css';
import { LocationBlockEntity } from '@/types/model';
import { Button } from '@/components';
import useIsMobile from '@/hooks/use-is-mobile';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';

const LocationBlock = ({ bgDesktop, bgMobile, contentString, title }: LocationBlockEntity) => {
  const t = useTranslations('common');
  const isMobile = useIsMobile();

  const router = useRouter();

  const handleClick = () => {
    router.push('/ubicacion');
  };
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <Image
        className={s.background}
        src={isMobile ? ImageLoader({ src: bgMobile?.url }) : ImageLoader({ src: bgDesktop?.url })}
        alt="background"
        fill
        sizes="100vw"
        quality={65}
      />
      <div className={s.container__content}>
        <div className={s.container__content__ubication}>
          <h3>{title}</h3>
          <p>{contentString}</p>
          <Button label={t('seeMore')} onClick={handleClick} />
        </div>
        <div className={s.container__content__map_container}>maps</div>
      </div>
    </motion.div>
  );
};

export default LocationBlock;
